import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Greenhouse from './components/Greenhouse';
import Sustainability from './components/Sustainability';
import Vision from './components/Vision';
import TaglineCTA from './components/TaglineCTA';
import BlogPage from './components/BlogPage';
import BlogPostPage from './components/BlogPostPage';
import Team from './components/Team';
import WelcomeMessage from './components/WelcomeMessage';
import Gallery1 from './components/Gallery1';
import Gallery2 from './components/Gallery2';

export default function App() {
  const [dark, setDark] = useState(false);

  const toggleTheme = () => {
    setDark(d => {
      const next = !d;
      document.documentElement.classList.toggle('dark', next);
      return next;
    });
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <Navbar dark={dark} toggleTheme={toggleTheme} />

      <Routes>
        {/* Home page */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <WelcomeMessage />
              <About dark={dark} />
                            <Gallery1 />

              <Services dark={dark} />
              <Greenhouse />
              <Sustainability dark={dark} />
              <Vision dark={dark} />
              <TaglineCTA />
            </>
          }
        />

        <Route path="/meet-the-team" element={<Team dark={dark} />} />


        {/* Blog listing page */}
        <Route path="/blog" element={<BlogPage dark={dark} />} />

        {/* Individual blog post page */}
        <Route path="/blog/:slug" element={<BlogPostPage dark={dark} />} />

        {/* Gallery page */}
        <Route path="/gallery" element={<Gallery2 />} />
      </Routes>

      <Footer dark={dark} />
    </div>
  );
}
